/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { fetchAsJson } from '@modules/query/helpers'
import type { SaasAuthMfaDevicesResponse } from '@modules/cloud-api/v1/types'
import { getSaasUserMfaDevicesUrl, resetSaasUserMfaUrl } from '@modules/cloud-api/v1/urls'

export const getSaasUserMfaDevices: (userId: string) => Promise<SaasAuthMfaDevicesResponse> = (
  userId,
) =>
  fetchAsJson<SaasAuthMfaDevicesResponse>(getSaasUserMfaDevicesUrl({ userId }), {
    method: 'get',
  })

export const resetSaasUserMfa: (userId: string, deviceId?: string) => Promise<unknown> = (
  userId,
  deviceId,
) =>
  fetchAsJson<unknown>(resetSaasUserMfaUrl({ userId, deviceId }), {
    method: 'post',
  })
